import React from 'react';
import Icon from '../../../components/AppIcon';

const VerificationProgressBar = ({ completedFields, totalFields, percentage }) => {
  return (
    <div className="w-full mb-8">
      <div className="flex items-center justify-between mb-2">
        <span className="text-sm font-medium text-[var(--color-foreground)]">
          Profile Completion
        </span>
        <span className="text-sm font-semibold text-[var(--color-primary)]">
          {percentage}%
        </span>
      </div>
      <div className="w-full h-3 bg-[var(--color-muted)] rounded-full overflow-hidden">
        <div
          className="h-full rounded-full transition-all duration-500 ease-out"
          style={{
            width: `${percentage}%`,
            background: 'linear-gradient(90deg, var(--color-primary), var(--color-secondary))'
          }}
        />
      </div>
      <div className="flex items-center justify-between mt-2">
        <span className="text-xs text-[var(--color-muted-foreground)]">
          {completedFields} of {totalFields} fields completed
        </span>
        {percentage === 100 && (
          <div className="flex items-center gap-1 text-[var(--color-success)]">
            <Icon name="CheckCircle" size={14} />
            <span className="text-xs font-medium">Ready to proceed!</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default VerificationProgressBar;
